export const VALID_INTEGER_REGEX = /^\d*$/;

export default function isValidInteger(n) {
  return VALID_INTEGER_REGEX.test(n);
}
